//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import timeLine from './timeLine.vue'
export default {
    components: {
        timeLine
    },
    data() {
        return {
            map: null,
            goodsOrderId: '',
            goodsOrder: {},
            isEnd: false,
            deliver: {
                name: '',
                phone: ''
            },
            logList: [],
        }
    },
    methods: {
        copyLogisticsNum() {
            let that = this;
            that.$copyText(that.goodsOrder.logisticsNum).then(function (e) {
                that.$vux.toast.text('复制成功')
            }, function (e) {
                that.$vux.toast.text('复制失败，请进行手动复制')
            })
        },
        loadLogistics() {
            let that = this;
            that.$axios.get('/api/v1.0/lonbonShop/viewLogistics', {
                params: {
                    goodsOrderId: that.goodsOrderId
                }
            }).then(function (response) {
                if (response.status == 200) {
                    var one = that.goodsOrder;

                    that.isEnd = false;
                    var addressList = [];
                    var list = response.body.data;
                    if (list && list.length > 0) {
                        //设置快递员数据
                        that.setDeliveryInfo(list);

                        for (var i = (list.length - 1); i >= 0; i--) {
                            var item = list[i];
                            if (item.opCode == 50 || item.opCode == 54) {
                                item.title = '已揽件';
                            }
                            if (item.opCode == 80) {
                                item.title = '已签收';
                            }
                            if (item.opCode == 44 || item.opCode == 204) {
                                item.title = '派送中';
                            }
                            if (item.opCode != 8000) {
                                if (item.acceptTime) {
                                    var acceptTimeArr = item.acceptTime.split(" ");
                                    var dateArr = acceptTimeArr[0].split("-");
                                    item.date = dateArr[1] + '-' + dateArr[2];
                                    var timeArr = acceptTimeArr[1].split(":");
                                    item.time = timeArr[0] + ':' + timeArr[1];
                                }
                                that.logList.push(item);

                                //用于添加地图显示的数据
                                if (item.acceptAddress && addressList.indexOf(item.acceptAddress) < 0) {
                                    addressList.unshift(item.acceptAddress);
                                }
                            }
                            if (item.opCode == 80) {
                                that.isEnd = true;
                            }

                            item.remark = that.replacePhoneHtml(item.remark);
                        }
                    }


                    //用于添加地图显示的数据
                    var addressArr = one.address.split(" ");
                    // console.log('地址列表1' + JSON.stringify(addressArr));
                    addressList.push(addressArr[0] + (addressArr[1] ? addressArr[1] : '') + (addressArr[2] ? addressArr[2] : ''));
                    // console.log('地址列表2' + JSON.stringify(addressList));

                    that.initMap(addressList);

                    /**
                     * 用于补充时间线
                     */
                    var disposeTimeArr = that.$moment(one.disposeTime * 1000).format("MM-DD HH:mm").split(' ');
                    that.logList.push({
                        opCode: 1,
                        date: disposeTimeArr[0],
                        time: disposeTimeArr[1],
                        title: '已发货',
                        remark: '商品正在等待揽收'
                    })

                    var createTimeArr = that.$moment(one.createTime * 1000).format("MM-DD HH:mm").split(' ');
                    that.logList.push({
                        opCode: 0,
                        date: createTimeArr[0],
                        time: createTimeArr[1],
                        title: '已下单',
                        remark: '商品已下单'
                    })

                    that.logList.unshift({
                        opCode: 9999,
                        remark: '[收货地址]' + one.address
                    })


                    /**
                     * 设置最近一次运输节点code为39
                     */
                    that.setLastTransCode();

                }
            })
        },
        loadDetail() {
            let that = this;
            that.$axios.get('/api/v1.0/lonbonShop/orderDetails', {
                params: {
                    goodsOrderId: that.goodsOrderId
                }
            }).then(function (response) {
                if (response.status == 200) {
                    that.goodsOrder = response.body;
                    that.loadLogistics();
                }
            })
        },
        //初始化地图
        async initMap(addressList) {
            this.map = new AMap.Map("map");
            var pointList = [], titleList = [], getAddressFunList = [];
            addressList.forEach((str) => {
                getAddressFunList.push(this.localSearch(str));
            })
            Promise.all(getAddressFunList).then(async (result) => {
                result.forEach((res) => {
                    pointList.push(res.point);
                    titleList.push(res.title);
                })
                console.log(result);
                if(pointList.length <= 0) {
                    return
                }
                if (pointList.length > 1) {
                    let newPointList = await this.drivingSearch(addressList)
                    var polyline = new AMap.Polyline({
                        path: newPointList,  
                        borderWeight: 3, // 线条宽度，默认为 1
                        strokeColor: '#409eff', // 线条颜色
                        lineJoin: 'round', // 折线拐点连接处样式
                        strokeOpacity: 1
                    });
                    this.map.add(polyline);

                    let m1 = this.addMarker({
                        content: `<div class='marker-point' style="border: 2px solid #1B7CFF"></div>`,
                        position: newPointList[0],
                        offset: new AMap.Pixel(-12, -12),
                        label: {
                            direction: 'top',
                            offset: new AMap.Pixel(0, -6),
                            content: "发 " + titleList[0]
                        }
                    })
                    let m2 = this.addMarker({
                        content: `<div class='marker-point' style="border: 2px solid #67DF69"></div>`,
                        position: newPointList[newPointList.length - 1],
                        offset: new AMap.Pixel(-12, -12),
                        label: {
                            direction: 'top',
                            offset: new AMap.Pixel(0, -6),
                            content: "收 " + titleList[titleList.length - 1]
                        }
                    })
                    this.map.setFitView(
                        [m1, m2],
                        false,  // 动画过渡到制定位置
                        [60, 150, 60, 60],  // 周围边距，上、下、左、右)
                    )
                } else{
                    let m1 = this.addMarker({
                        content: `<div class='marker-point' style="border: 2px solid #67DF69"></div>`,
                        position: pointList[pointList.length - 1],
                        offset: new AMap.Pixel(-12, -12),
                        label: {
                            direction: 'top',
                            offset: new AMap.Pixel(0, -6),
                            content: "收 " + titleList[titleList.length - 1]
                        }
                    })
                    this.map.setFitView(
                        [m1],
                        false,  // 动画过渡到制定位置
                        [60, 150, 60, 60],  // 周围边距，上、下、左、右)
                    )
                }

            }).catch((error) => {
                console.log(error);
            })
        },
        addMarker(opts) {
            let marker = new AMap.Marker(opts);
            marker.setMap(this.map);
            return marker
        },
        /**
         * 根据地名查坐标
         */
        localSearch(value) {
            var promise = new Promise((resolve) => {
                AMap.plugin('AMap.PlaceSearch', () => {
                    var placeSearch = new AMap.PlaceSearch()
                    placeSearch.search(value, (status, result) => {
                        // 查询成功时，result即对应匹配的POI信息
                        console.log(result);
                        if(result && result.poiList && result.poiList.pois) {
                            let item = result.poiList.pois[0]
                            resolve({
                                point: [item.location.lng,item.location.lat],
                                title: item.name
                            })
                        } else {
                            resolve({})
                        }
                    })
                })
            })
            return promise;
        },
        //路线规划
        drivingSearch(addressList) {
            return new Promise(resolve => {
                AMap.plugin('AMap.Driving', function() {
                    var driving = new AMap.Driving({
                        // 驾车路线规划策略，AMap.DrivingPolicy.LEAST_TIME是最快捷模式
                        policy: AMap.DrivingPolicy.LEAST_TIME
                    })
                    
                    var points = addressList.map(item => {
                        return { keyword: item }
                    })
                    
                    driving.search(points, function (status, result) {
                        if(status != 'complete') {
                            resolve([])
                            return
                        }
                        let route = result.routes[0]
                        console.log(route);
                        resolve(route.steps.map(({start_location} )=> {
                            return [start_location.lng, start_location.lat]
                        }))
                    })
                })
            })
        },
        /**
         * 标识最新一条的运输数据
         */
        setLastTransCode() {
            for (var i = 0; i < this.logList.length; i++) {
                var opCode = this.logList[i].opCode;
                if (opCode == 30 || opCode == 31 || opCode == 36) {
                    this.logList[i].opCode = 39;
                    this.logList[i].title = '运输中';
                    break
                }
            }
        },
        /**
         * 查询派送信息：快递员姓名和电话
         */
        setDeliveryInfo(dataList) {
            for (var i = 0; i < dataList.length; i++) {
                var item = dataList[i];
                var remark = item.remark;
                var opCode = item.opCode;
                if (opCode == 204) {
                    var nameObj = remark.match(/交给(\S*),正在/);
                    var phoneObj = remark.match(/联系电话：(\S*),顺丰/);
                    this.deliver = {
                        name: nameObj ? nameObj[1] : '',
                        phone: phoneObj ? phoneObj[1] : ''
                    }
                }
                if (opCode == 44) {
                    var arr = remark.match(/\(派件人:(\S*),电话:(\S*)\)/);
                    if (arr) {
                        this.deliver = {
                            name: arr[1],
                            phone: arr[2]
                        }
                    }
                }
            }
        },
        replacePhoneHtml(remark) {
            return remark.replace(/(\d{11})/g, '<a href="tel:$1">$1</a>');
        },
        deliverPhoneHandle() {
            this.$refs.deliverPhoneRef.dispatchEvent(new MouseEvent('click'));
        }
    },
    mounted() {
        var that = this;
        this.$vux.loading.show();
        setTimeout(() => {
            that.$vux.loading.hide();
        }, 1000);
        var goodsOrderId = that.$route.query.goodsOrderId;
        if (goodsOrderId) {
            this.goodsOrderId = goodsOrderId;
            this.loadDetail();
        } else {
            this.$router.push("/goods");
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/logistics/index.vue